<template>
    <div class="bg-img-container h-100">
        <v-container fluid>
            <v-row no-gutters="" justify="center">
                <v-col cols="0" sm="2"></v-col>
                <v-col cols="12" sm="8">
                    <v-card class="mt-6">
                        <router-view v-slot="{ Component, route }">
                            <transition name="router-anim">
                                <component :is="Component" />
                            </transition>
                        </router-view>
                        <v-card-actions>
                            <v-btn @click="systemStore.routerTo('login')" width="100"
                            variant="text" class="mx-2 text-none">Back</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="0" sm="2"></v-col>
            </v-row>
        </v-container>

        <v-footer color="#212529" padless app>
            <v-row justify="center" no-gutters>
                <v-btn v-for="o, idx in systemStore.footerLinksNoauth" :key="idx" color="transparent" elevation="0" @click="systemStore.routerTo(o.routeName)"
                    text class="my-2 mx-2 text-none">
                    {{ o.text }}
                </v-btn>
            </v-row>
        </v-footer>

    </div>

</template>

<script setup>
import router from '../router'
import { ref, onMounted } from 'vue'

import { useSystemStore } from '@/stores/system'
const systemStore = useSystemStore()


onMounted(() => {
})

const icons = [
    'mdi-home',
    'mdi-email',
    'mdi-calendar',
    'mdi-delete'
]

const links = [
    { text: '© Dell Technologies 2024', enabled: false },
    { text: 'Terms Of Use', enabled: true },
    { text: 'Privacy Statement', enabled: true },
    { text: 'Cookies Information', enabled: true },
    { text: 'Contact', enabled: true }
]

</script>

<style >

.bg-img-container {
    background: url(../img/login-bg.jpg) no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
</style>